import React from 'react';
import { Button, Form, Header, Segment, Grid, Input } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { withRouter } from 'react-router-dom';
import UiShared from 'stores/UiShared';
import MsgStore from 'stores/MsgStore';
import * as styles from './styles';
import MessageBox from 'components/MessageBox';
import API from '../../../api/index';
import Rx from 'stores/Rx';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';

@withRouter
@inject(root => ({
	uiShared: root.uiShared,
	user: root.auth.user
}))
@observer
export default class Playground extends React.Component {
	props: {
		uiShared?: UiShared,
		user?: Account
	};

	msgStore: MsgStore = new MsgStore();

	@observable active = {};
	@observable responseData = '';
	@observable param: string = '';
	@observable prodaLoggedIn: boolean = false;
	@observable prodaRedirectUri: string = '';
	@observable prodaClientId: string = '';
	@observable prodaBaseUrl: string = '';
	@observable inputParamsValue: string = '';
	@observable inputJsonValue: string = '';
	@observable loading: boolean = false;
	@observable
	commands = [
		{
			name: 'createAuthority',
			label: 'Create Authority',
			json: true
		},
		{
			name: 'updateAuthority',
			label: 'Update Authority',
			json: true
		},
		{
			name: 'enquireAuthority',
			label: 'Enquire Authority',
			params: 'prescriberID/authorityPrescriptionNumber/authorityUniqueId'
		},
		{
			name: 'cancelAuthority',
			label: 'Cancel Authority',
			params: 'prescriberID/authorityPrescriptionNumber/authorityUniqueId'
		},
		{
			name: 'getRestrictionQuestion',
			label: 'Get Restriction Question',
			params: 'prescriberID/itemCode/restrictionCode'
		},
		{
			name: 'getQuestion',
			label: 'Get Question',
			params: 'prescriberID/itemCode/restrictionCode'
		}
	];

	async componentDidMount() {
		const res = await API.get('/ProdaActivities/getTokenStatus');
		this.prodaLoggedIn = res.status === 'OK';
		this.prodaRedirectUri = res.prodaRedirectUri;
		this.prodaClientId = res.prodaClientId;
		this.prodaBaseUrl = res.prodaBaseUrl;
		const errorIndex = window.location.hash.indexOf('?error=');
		if (errorIndex > -1) {
			this.msgStore.setError(decodeURIComponent(window.location.hash.substring(errorIndex + 7)));
		}
	}

	prettyPrintJson = data => (
		<div>
			<pre className={styles.pre}>{JSON.stringify(data, null, 2)}</pre>
		</div>
	);

	call = async () => {
		try {
			this.responseData = '';
			this.msgStore.clear();
			this.loading = true;
			const { inputParamsValue, inputJsonValue } = this;
			const { name, json } = this.active;
			const body = json ? inputJsonValue : { inputParams: encodeURI(inputParamsValue.trim()) };
			let req = {
				name,
				body
			};
			let response = await Rx.callProda(req);
			this.responseData = response;
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			this.loading = false;
		}
	};

	setActive = val => {
		this.inputJsonValue = '';
		this.inputParamsValue = '';
		this.responseData = '';
		this.msgStore.clear();
		this.active = val;
	};

	prodaLogOut = async () => {
		const user: Account = this.props.user;
		await API.get(`/ProdaActivities/deleteAccessToken/${user.id}`);
		this.prodaLoggedIn = false;
	};

	render() {
		const { name, label, params, json } = this.active;
		const { inputJsonValue, inputParamsValue, responseData } = this;

		return (
			<Segment>
				<Grid>
					<Grid.Row>
						<Grid.Column width={4}>
							<Header as="h1">Medicare Playground</Header>
							<h3 className={styles.section}>API endpoints:</h3>
							{this.commands.map(c => (
								<div
									key={c.name}
									onClick={() => this.setActive(c)}
									className={styles.commandLabel}
									style={label === c.label ? { fontWeight: 'bold', fontSize: '1.4em' } : {}}
								>
									{c.label}
								</div>
							))}
						</Grid.Column>
						<Grid.Column width={12}>
							<Grid>
								<Grid.Row>
									<Grid.Column width={16}>
										<div>
											{' '}
											{this.prodaLoggedIn ? (
												<Button primary floated="right" onClick={() => this.prodaLogOut()}>
													PRODA Log Out
												</Button>
											) : (
												<Button
													primary
													floated="right"
													onClick={() => {
														window.location.href = `${
															this.prodaBaseUrl
														}/authorize?response_type=code&client_id=${
															this.prodaClientId
														}&redirect_uri=${this.prodaRedirectUri}&scope=PBSAuthorities`;
													}}
												>
													PRODA Log In
												</Button>
											)}
										</div>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column width={16}>
										{name && (
											<Form>
												{!json && (
													<Form.Field>
														<label className={styles.lbl}>{params}</label>
														<Input
															value={inputParamsValue || ''}
															onChange={e => {
																this.inputParamsValue = e.target.value;
															}}
														/>
													</Form.Field>
												)}
												{json && (
													<Form.Field>
														<label className={styles.lbl}>JSON</label>
														<Segment style={{ padding: '0px' }}>
															<AceEditor
																placeholder=""
																mode="json"
																theme="monokai"
																name="inputJsonEdit"
																width="100%"
																height="300px"
																onLoad={this.onLoad}
																fontSize={14}
																showPrintMargin={false}
																showGutter={false}
																highlightActiveLine={true}
																value={inputJsonValue}
																onChange={e => (this.inputJsonValue = e)}
																wrapEnabled={true}
																setOptions={{
																	enableBasicAutocompletion: false,
																	enableLiveAutocompletion: false,
																	enableSnippets: false,
																	showLineNumbers: true,
																	tabSize: 2
																}}
															/>
														</Segment>
													</Form.Field>
												)}
												<Form.Field>
													<Button
														primary
														onClick={() => this.call()}
														floated="left"
														disabled={!inputJsonValue && !inputParamsValue}
													>
														Call
													</Button>
												</Form.Field>
											</Form>
										)}
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column width={16}>
										<MessageBox msgStore={this.msgStore} />
										{name && (
											<div style={{ paddingTop: '30px' }}>
												<span className={styles.lbl}>RESULT</span>
												<Segment loading={this.loading}>
													{responseData && this.prettyPrintJson(responseData)}
												</Segment>
											</div>
										)}
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/Manager/Playground/index.js